import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useCollapse } from './hooks/useCollapse';
import { useTraceBoardItemElements } from './hooks/useTraceBoardItemElements';
import { isTraceBoardItemEqual } from './utils/isTraceBoardItemEqual';
export const TraceBoardContext = createContext(null);
export function useTraceBoardContext() {
    const context = useContext(TraceBoardContext);
    if (!context) {
        throw new Error('useTraceBoardContext must be used within the TraceBoardProvider component');
    }
    return context;
}
export const TraceBoardProvider = props => {
    const { rows, columns, children } = props;
    const [selected, setSelected] = useState();
    const [loadingItems, setLoadingItems] = useState([]);
    const collapse = useCollapse(rows.length);
    const elements = useTraceBoardItemElements(columns);
    const isItemLoading = useCallback((item) => {
        return loadingItems.some(loadingItem => {
            return isTraceBoardItemEqual(loadingItem, item);
        });
    }, [loadingItems]);
    const setItemLoading = useCallback((item, isLoading) => {
        setLoadingItems(loadingItems => {
            const index = loadingItems.findIndex(loadingItem => {
                return isTraceBoardItemEqual(loadingItem, item);
            });
            if (index === -1 && isLoading) {
                return loadingItems.concat(item);
            }
            else if (index > -1 && !isLoading) {
                const copy = Array.from(loadingItems);
                copy.splice(index, 1);
                return copy;
            }
            return loadingItems;
        });
    }, []);
    const context = useMemo(() => {
        return {
            rows,
            columns,
            collapse,
            elements,
            selected,
            loadingItems,
            isItemLoading,
            setItemLoading,
            setSelected
        };
    }, [
        rows,
        columns,
        collapse,
        elements,
        selected,
        loadingItems,
        isItemLoading,
        setItemLoading
    ]);
    return (React.createElement(TraceBoardContext.Provider, { value: context }, children));
};
//# sourceMappingURL=TraceBoardContext.js.map